import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { ISelectListItem } from '../../interfaces/i-select-list-item';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss'],
})
export class SearchListComponent {
  @Input() selectedList: ISelectListItem[];
  @Input() searchResults: IAutoCompleteData[];
  @Input() searchFormControl: FormControl;

  @Input() isSearching: boolean;
  @Input() isAddButtonShown: boolean = true;
  @Input() isInfoButtonShown: boolean = true;
  @Input() isSurtitleButtonShown: boolean = false;
  @Input() placeholder: string = 'Search';
  @Input() isSurtitles: boolean = false;
  @Input() addToBodyFormats?: { label: string; format?: string }[];

  @Output() handleRemove = new EventEmitter();
  @Output() handleAdd = new EventEmitter();

  @Output() handleAddToBody = new EventEmitter<ISelectListItem>();
  @Output() handleAddToBodyFormatted = new EventEmitter<{
    item: ISelectListItem;
    format?: string;
  }>();
  @Output() handleInfoClick = new EventEmitter<ISelectListItem>();
  @Output() handlePromote = new EventEmitter<ISelectListItem>();

  hoveredItem: ISelectListItem;

  onRemove(item: ISelectListItem) {
    this.handleRemove.emit(item);
  }

  onAdd(item: ISelectListItem) {
    this.handleAdd.emit(item);
  }

  onAddToBody(item: ISelectListItem) {
    this.handleAddToBody.emit(item);
  }

  onAddToBodyFormatted(item: ISelectListItem, format?: string): void {
    this.handleAddToBodyFormatted.emit({ item, format });
  }

  onInfoClick(item: ISelectListItem) {
    this.handleInfoClick.emit(item);
  }

  promoteToSurtitle(item: ISelectListItem) {
    this.handlePromote.emit(item);
  }
}
